/**
 * Whether a slide element is on screen as far as Reveal's fragments go: one
 * inside a .fragment shows only once the slide has revealed that step.
 *
 * Shared by RevealRenderer, which blurs an unrevealed input box and ignores
 * clicks on it, and the dev overlay's tutor.setInput, which refuses the same
 * boxes, so the two cannot disagree.
 */
export function isInRevealedFragment(element: Element): boolean {
  const fragment = element.closest(".fragment");
  return !fragment || fragment.classList.contains("visible");
}
